type Result =
  | {
      type: 'error';
      error: string;
    }
  | {
      type: 'success';
    }
  | {
      type: 'cancel';
    };

let _setSuperUserPassword: (password: string) => Promise<Result>;

export function setSuperUserPasswordSetterFunction(
  setSuperUserPassword: (password: string) => Promise<Result>,
): void {
  _setSuperUserPassword = setSuperUserPassword;
}

export function setSuperUserPassword(password: string) {
  return _setSuperUserPassword?.(password);
}
